import { MuiStyles } from "@osu/react-ui";
    
function classCreatorFn(theme) {
    return {
        errorClass: {
            color: theme.palette.colors.red,
            fontWeight: "bold",
        },
        darkLightColor: {
            color: theme.palette.text.primary,
        }
    };
}

export default function useCommonStyles() {
    const commonClasses = classCreatorFn(MuiStyles.useTheme());

    return commonClasses;
}